import type { AxiosError } from 'axios';
import { isUnadjudicated } from 'lib/auth/session-error';

/**
 * React Query `retry` predicate that gives up immediately on client errors.
 *
 * A 4xx says the request itself is wrong — an event whose sale has ended (410
 * Gone), or a special offer that doesn't cover the requested event (404) — so
 * retrying only delays the error state the UI needs to show. Server and network
 * errors still get the default three attempts.
 */
export const retryUnlessClientError = (
  failureCount: number,
  error: unknown
): boolean => {
  // A 401 the auth interceptor could never adjudicate is a round-trip that
  // didn't complete wearing a 4xx's clothes — retry it like the 5xx it really
  // was, and it may yet produce a real answer.
  if (isUnadjudicated(error)) return failureCount < 3;
  const status = (error as AxiosError | undefined)?.response?.status;
  if (status && status >= 400 && status < 500) return false;
  return failureCount < 3;
};
